<div class="list" [class.list-with-projects]="onkoProjektitKaytossa" [class.list-kuvilla]="esitystapa !== 'tiivis'">
  <div class="list-head">
    @if (sorttausKaytossa) {
      <button type="button" class="list-th list-th-date" [class.list-th-active]="nykyinenSorttaus?.active === 'pvm'" (click)="jarjesta('pvm')" [attr.aria-label]="('tositteet.jarjesta-pvm' | translate | async) + (nykyinenSorttaus?.active === 'pvm' ? ', ' + (nykyinenSorttaus.direction === 'asc' ? ('tositteet.nouseva' | translate | async) : ('tositteet.laskeva' | translate | async)) : '')">
        <span>{{ 'tositteet.paivamaara' | translate | async }}</span>
        <span class="sort-icon" [class.sort-icon-active]="nykyinenSorttaus?.active === 'pvm'" [attr.data-suunta]="nykyinenSorttaus?.active === 'pvm' ? nykyinenSorttaus.direction : null" aria-hidden="true"></span>
      </button>

      <button
        type="button"
        class="list-th list-th-supplier"
        [class.list-th-active]="nykyinenSorttaus?.active === 'toimittaja'"
        (click)="jarjesta('toimittaja')"
        [attr.aria-label]="('tositteet.jarjesta-toimittaja' | translate | async) + (nykyinenSorttaus?.active === 'toimittaja' ? ', ' + (nykyinenSorttaus.direction === 'asc' ? ('tositteet.nouseva' | translate | async) : ('tositteet.laskeva' | translate | async)) : '')"
      >
        <span>{{ 'tositteet.toimittaja' | translate | async }}</span>
        <span class="sort-icon" [class.sort-icon-active]="nykyinenSorttaus?.active === 'toimittaja'" [attr.data-suunta]="nykyinenSorttaus?.active === 'toimittaja' ? nykyinenSorttaus.direction : null" aria-hidden="true"></span>
      </button>

      @if (onkoProjektitKaytossa) {
        <button
          type="button"
          class="list-th list-th-project"
          [class.list-th-active]="nykyinenSorttaus?.active === 'projekti'"
          (click)="jarjesta('projekti')"
          [attr.aria-label]="('tositteet.jarjesta-projekti' | translate | async) + (nykyinenSorttaus?.active === 'projekti' ? ', ' + (nykyinenSorttaus.direction === 'asc' ? ('tositteet.nouseva' | translate | async) : ('tositteet.laskeva' | translate | async)) : '')"
        >
          <span>{{ 'tositteet.projekti' | translate | async }}</span>
          <span class="sort-icon" [class.sort-icon-active]="nykyinenSorttaus?.active === 'projekti'" [attr.data-suunta]="nykyinenSorttaus?.active === 'projekti' ? nykyinenSorttaus.direction : null" aria-hidden="true"></span>
        </button>
      }

      <div class="list-th list-th-static list-th-notes">{{ 'tositteet.lisatiedot' | translate | async }}</div>

      <button
        type="button"
        class="list-th list-th-pm"
        [class.list-th-active]="nykyinenSorttaus?.active === 'maksutapa'"
        (click)="jarjesta('maksutapa')"
        [attr.aria-label]="('tositteet.jarjesta-maksutapa' | translate | async) + (nykyinenSorttaus?.active === 'maksutapa' ? ', ' + (nykyinenSorttaus.direction === 'asc' ? ('tositteet.nouseva' | translate | async) : ('tositteet.laskeva' | translate | async)) : '')"
      >
        <span>{{ 'tositteet.maksutapa' | translate | async }}</span>
        <span class="sort-icon" [class.sort-icon-active]="nykyinenSorttaus?.active === 'maksutapa'" [attr.data-suunta]="nykyinenSorttaus?.active === 'maksutapa' ? nykyinenSorttaus.direction : null" aria-hidden="true"></span>
      </button>

      <button
        type="button"
        class="list-th list-th-right list-th-amount"
        [class.list-th-active]="nykyinenSorttaus?.active === 'summa'"
        (click)="jarjesta('summa')"
        [attr.aria-label]="('tositteet.jarjesta-summa' | translate | async) + (nykyinenSorttaus?.active === 'summa' ? ', ' + (nykyinenSorttaus.direction === 'asc' ? ('tositteet.nouseva' | translate | async) : ('tositteet.laskeva' | translate | async)) : '')"
      >
        <span class="sort-icon" [class.sort-icon-active]="nykyinenSorttaus?.active === 'summa'" [attr.data-suunta]="nykyinenSorttaus?.active === 'summa' ? nykyinenSorttaus.direction : null" aria-hidden="true"></span>
        <span>{{ 'tositteet.summa' | translate | async }}</span>
      </button>
    } @else {
      <div class="list-th list-th-static list-th-date">
        <span>{{ 'tositteet.paivamaara' | translate | async }}</span>
      </div>
      <div class="list-th list-th-static list-th-supplier">
        <span>{{ 'tositteet.toimittaja' | translate | async }}</span>
      </div>
      @if (onkoProjektitKaytossa) {
        <div class="list-th list-th-static list-th-project">
          <span>{{ 'tositteet.projekti' | translate | async }}</span>
        </div>
      }
      <div class="list-th list-th-static list-th-notes">{{ 'tositteet.lisatiedot' | translate | async }}</div>
      <div class="list-th list-th-static list-th-pm">
        <span>{{ 'tositteet.maksutapa' | translate | async }}</span>
      </div>
      <div class="list-th list-th-static list-th-right list-th-amount">
        <span>{{ 'tositteet.summa' | translate | async }}</span>
      </div>
    }

    <div class="list-th-status"></div>
  </div>

  @if (esitystapa === 'kortit') {
    <div class="kortit">
      @for (rivi of rivit; track rivi.id) {
        <div
          class="kortti"
          [class.list-row-processing]="rivi.kasittelyKesken"
          role="button"
          tabindex="0"
          (click)="riviKlikattu.emit(rivi.id)"
          (keydown.enter)="riviKlikattu.emit(rivi.id)"
          (keydown.space)="$event.preventDefault(); riviKlikattu.emit(rivi.id)"
          [attr.aria-label]="('tositteet.tosite-aria' | translate | async) + ': ' + (rivi.toimittajanNimi || ('tositteet.ei-toimittajaa' | translate | async)) + ', ' + (rivi.paivamaara | lnumberpvm | async) + ', ' + (rivi.summa | lmoney: 'EUR' | async)"
        >
          <div class="kortti-kuva">
            @if (rivi.kansikuvaUrl) {
              <div app-tosite-kuva class="kuvarivi-kuva-sisalto" [url]="rivi.kansikuvaUrl" [pikkukuva]="true" [pikkukuvanLeveys]="130" [viivastetty]="true"></div>
            } @else {
              <div class="kuvarivi-ei-kuvaa">{{ 'tositteet.ei-kuvaa' | translate | async }}</div>
            }
            @if ((rivi.kuvia ?? 0) > 1) {
              <span class="kuvarivi-sivumaara" aria-hidden="true">{{ rivi.kuvia }}</span>
            }
          </div>

          <div class="kortti-tiedot">
            <div class="kortti-pvm">{{ rivi.paivamaara | lnumberpvm | async }}</div>
            <div class="kortti-summa">{{ rivi.summa | lmoney: 'EUR' | async }}</div>
            <div class="kortti-viiva"></div>
            <div class="kortti-toimittaja" [class.list-supplier-missing]="!rivi.toimittajanNimi">
              {{ rivi.toimittajanNimi || ('tositteet.ei-toimittajaa' | translate | async) }}
            </div>
            @if (rivi.lisatiedot) {
              <div class="kortti-lisatiedot">{{ rivi.lisatiedot }}</div>
            }
            <div class="kuvarivi-alarivi">
              <span class="kuvarivi-maksutapa">{{ rivi.maksutapa?.l }}</span>
              @if (onkoProjektitKaytossa) {
                @if (projektitMap.get(rivi.projektinId ?? ''); as p) {
                  <span class="project-chip" [style.background]="p.taustavari" [style.color]="p.varikoodi">{{ p.nimi }}</span>
                }
              }
              @if (rivi.kasittelyKesken) {
                <span class="material-symbols-outlined status-kesken kuvarivi-status" [attr.title]="'tositteet.kasitellaan' | translate | async" aria-hidden="true">cloud_upload</span>
              }
            </div>
          </div>
        </div>
      }
    </div>
  } @else {
    @for (rivi of rivit; track rivi.id) {
      <div
        class="list-row-wrapper"
        [class.list-row-processing]="rivi.kasittelyKesken"
        role="button"
        tabindex="0"
        (click)="riviKlikattu.emit(rivi.id)"
        (keydown.enter)="riviKlikattu.emit(rivi.id)"
        (keydown.space)="$event.preventDefault(); riviKlikattu.emit(rivi.id)"
        [attr.aria-label]="('tositteet.tosite-aria' | translate | async) + ': ' + (rivi.toimittajanNimi || ('tositteet.ei-toimittajaa' | translate | async)) + ', ' + (rivi.paivamaara | lnumberpvm | async) + ', ' + (rivi.summa | lmoney: 'EUR' | async)"
      >
        @if (esitystapa === 'kuvilla') {
          <div class="kuvarivi">
            <div class="kuvarivi-kuva">
              @if (rivi.kansikuvaUrl) {
                <div app-tosite-kuva class="kuvarivi-kuva-sisalto" [url]="rivi.kansikuvaUrl" [pikkukuva]="true" [viivastetty]="true"></div>
              } @else {
                <div class="kuvarivi-ei-kuvaa">{{ 'tositteet.ei-kuvaa' | translate | async }}</div>
              }
              @if ((rivi.kuvia ?? 0) > 1) {
                <span class="kuvarivi-sivumaara" aria-hidden="true">{{ rivi.kuvia }}</span>
              }
            </div>

            <div class="kuvarivi-tiedot">
              <div class="kuvarivi-otsikko">
                <div class="kuvarivi-toimittaja" [class.list-supplier-missing]="!rivi.toimittajanNimi">
                  {{ rivi.toimittajanNimi || ('tositteet.ei-toimittajaa' | translate | async) }}
                </div>
                <div class="kuvarivi-summa">{{ rivi.summa | lmoney: 'EUR' | async }}</div>
              </div>
              <div class="kuvarivi-pvm">{{ rivi.paivamaara | lnumberpvm | async }}</div>
              @if (rivi.lisatiedot) {
                <div class="kuvarivi-lisatiedot">{{ rivi.lisatiedot }}</div>
              }
              <div class="kuvarivi-alarivi">
                <span class="kuvarivi-maksutapa">{{ rivi.maksutapa?.l }}</span>
                @if (onkoProjektitKaytossa) {
                  @if (projektitMap.get(rivi.projektinId ?? ''); as p) {
                    <span class="project-chip" [style.background]="p.taustavari" [style.color]="p.varikoodi">{{ p.nimi }}</span>
                  }
                }
                @if (rivi.kasittelyKesken) {
                  <span class="material-symbols-outlined status-kesken kuvarivi-status" [attr.title]="'tositteet.kasitellaan' | translate | async" aria-hidden="true">cloud_upload</span>
                }
              </div>
            </div>
          </div>
        } @else {
          <div class="list-row">
            <div class="list-date">{{ rivi.paivamaara | lnumberpvm | async }}</div>

            <div class="list-supplier" [class.list-supplier-missing]="!rivi.toimittajanNimi">
              {{ rivi.toimittajanNimi || ('tositteet.ei-toimittajaa' | translate | async) }}
            </div>

            @if (onkoProjektitKaytossa) {
              <div class="list-project">
                @if (projektitMap.get(rivi.projektinId ?? ''); as p) {
                  <span class="project-chip" [style.background]="p.taustavari" [style.color]="p.varikoodi">{{ p.nimi }}</span>
                }
              </div>
            }

            <div class="list-notes">{{ rivi.lisatiedot }}</div>

            <div class="list-pm">
              {{ rivi.maksutapa?.l }}
            </div>

            <div class="list-amount">{{ rivi.summa | lmoney: 'EUR' | async }}</div>

            <div class="list-status">
              @if (rivi.kasittelyKesken) {
                <span class="material-symbols-outlined status-kesken" [attr.title]="'tositteet.kasitellaan' | translate | async" aria-hidden="true">cloud_upload</span>
              }
            </div>
          </div>
        }
      </div>
    }
  }
</div>
